export default __webpack_public_path__ + "static/media/torba1.18fecd1a.png";